const initProductsList = (params) => {
  console.log('initProductsList')
  if (!productsList) return
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "ConnectedReactRouter" */ 'connected-react-router'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductsList" */ 'containers/ProductsListContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      ConnectedReactRouter,
      Store,
      LocalStorage,
      { default: ProductsList },
    ]) => {
      const { Provider } = ReactRedux
      const { ConnectedRouter } = ConnectedReactRouter
      const { history, store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <ProductsList LS={LS} history={history} />
          </ConnectedRouter>
        </Provider>,
        productsList
      )
    }
  )
}
const initProductsFilters = (params) => {
  console.log('initProductsFilters: ')
  if (!productsFilters && !productsFiltersTop && !productsFiltersBottom) return
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "ConnectedReactRouter" */ 'connected-react-router'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductsFilters" */ 'containers/ProductsFiltersContainer'),
    import(/* webpackChunkName: "ProductsFiltersTop" */ 'containers/ProductsFiltersTopContainer'),
    import(/* webpackChunkName: "ProductsFiltersBottom" */ 'containers/ProductsFiltersBottomContainer'),
    import(/* webpackChunkName: "ProductsActions" */ 'actions/productsActions'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      ConnectedReactRouter,
      Store,
      LocalStorage,
      { default: ProductsFilters },
      { default: ProductsFiltersTop },
      { default: ProductsFiltersBottom },
      ProductsActions,
    ]) => {
      const { Provider } = ReactRedux
      const { ConnectedRouter } = ConnectedReactRouter
      const { history, store } = Store
      const { LS } = LocalStorage
      const { requestFilters } = ProductsActions

      Promise.all([store.dispatch(requestFilters())]).then(() => {
        if (productsFilters) {
          ReactDOM.render(
            <Provider store={store}>
              <ConnectedRouter history={history}>
                <ProductsFilters LS={LS} history={history} />
              </ConnectedRouter>
            </Provider>,
            productsFilters
          )
        }

        if (productsFiltersTop) {
          ReactDOM.render(
            <Provider store={store}>
              <ConnectedRouter history={history}>
                <ProductsFiltersTop LS={LS} history={history} />
              </ConnectedRouter>
            </Provider>,
            productsFiltersTop
          )
        }

        if (productsFiltersBottom) {
          ReactDOM.render(
            <Provider store={store}>
              <ConnectedRouter history={history}>
                <ProductsFiltersBottom LS={LS} history={history} />
              </ConnectedRouter>
            </Provider>,
            productsFiltersBottom
          )
        }
      })
    }
  )
}
const initWholesalerRegistrationForm = () => {
  if (wholesalerRegistrationForm) {
    Promise.all([
      import(/* webpackChunkName: "React" */ 'react'),
      import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
      import(
        /* webpackChunkName: "WholesalerRegistrationForm" */ 'components/WholesalerRegistrationForm/WholesalerRegistrationForm'
      ),
    ]).then(([{ default: React }, { default: ReactDOM }, { default: WholesalerRegistrationForm }]) => {
      ReactDOM.render(<WholesalerRegistrationForm />, wholesalerRegistrationForm)
    })
  }
}
const initSupplierRegistrationForm = () => {
  if (supplierRegistrationForm) {
    Promise.all([
      import(/* webpackChunkName: "React" */ 'react'),
      import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
      import(
        /* webpackChunkName: "SupplierRegistrationForm" */ 'components/SupplierRegistrationForm/SupplierRegistrationForm'
      ),
    ]).then(([{ default: React }, { default: ReactDOM }, { default: SupplierRegistrationForm }]) => {
      ReactDOM.render(<SupplierRegistrationForm />, supplierRegistrationForm)
    })
  }
}
const initEventEnquirySignup = () => {
  if (eventEnquirySignup) {
    Promise.all([
      import(/* webpackChunkName: "React" */ 'react'),
      import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
      import(/* webpackChunkName: "WholesalerRegistrationForm" */ 'components/EventEnquirySignup/EventEnquirySignup'),
    ]).then(([{ default: React }, { default: ReactDOM }, { default: EventEnquirySignup }]) => {
      ReactDOM.render(<EventEnquirySignup />, eventEnquirySignup)
    })
  }
}

const initProductCarousel = (productCarousel, datasetBlockId) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "ConnectedReactRouter" */ 'connected-react-router'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductCarouselContainer" */ 'containers/ProductCarouselContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      ConnectedReactRouter,
      Store,
      LocalStorage,
      { default: ProductCarouselContainer },
    ]) => {
      const { Provider } = ReactRedux
      const { ConnectedRouter } = ConnectedReactRouter
      const { history, store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <ProductCarouselContainer LS={LS} history={history} datasetBlockId={datasetBlockId} />
          </ConnectedRouter>
        </Provider>,
        productCarousel
      )
    }
  )
}

const initJobApplicationForm = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "JobApplicationForm" */ 'containers/JobApplicationFormContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: JobApplicationForm }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <JobApplicationForm container={jobApplicationForm} />
      </Provider>,
      jobApplicationForm
    )
  })
}

const initDreamJobApplicationForm = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "JobApplicationForm" */ 'containers/JobApplicationFormContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: JobApplicationForm }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <JobApplicationForm container={dreamJobApplicationForm} />
      </Provider>,
      dreamJobApplicationForm
    )
  })
}

const initStore = () => {
  initEventEnquirySignup()

  for (let i = 0; i < productCarousels.length; i++) {
    initProductCarousel(productCarousels.item(i), productCarousels.item(i).dataset.blockId)
  }

  if (productsList || productsFiltersTop || productsFiltersBottom) {
    Promise.all([
      import(/* webpackChunkName: "Store" */ 'store/store'),
      import(/* webpackChunkName: "ProductsActions" */ 'actions/productsActions'),
      import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    ]).then(([Store, ProductsActions, LocalStorage]) => {
      const { store } = Store
      const { initializeSelectedFilters, setProductsFilters, setPerPageFromStorage, setActivePage } = ProductsActions
      // const { setPerPageFromStorage, setActivePage } = ProductsActions;
      const { handleAppVersioning } = LocalStorage

      handleAppVersioning()

      // store actions
      store.dispatch(initializeSelectedFilters())
      // store.dispatch(setProductsFilters());
      store.dispatch(setPerPageFromStorage())
      store.dispatch(setActivePage(window.pageIndex))

      // history.listen((location, action) => {
      //     store.dispatch(UndoRedo(location, action));
      // });

      initProductsList()
      initProductsFilters()
    })
  }

  initWholesalerRegistrationForm()
  initSupplierRegistrationForm()

  // SearchCustomerForm
  if (jobApplicationForm) {
    initJobApplicationForm()
  }

  if (dreamJobApplicationForm) {
    initDreamJobApplicationForm()
  }
}
const initDOM = () => {
  Promise.all([
    import(/* webpackChunkName: "jQuery" */ 'jquery'),
    import(/* webpackChunkName: "@sentry/react" */ '@sentry/react'),
    import(/* webpackChunkName: "@sentry/tracing" */ '@sentry/tracing'),
    import(/* webpackChunkName: "bootstrap" */ 'bootstrap'),
  ]).then(([{ default: $ }, Sentry, SentryTracing]) => {
    /* Sentry integration for catching React errors */
    const { BrowserTracing } = SentryTracing
    const SENTRY_DSN = 'https://c9d93d59b3d0467187919204e9c30887@sentry.visualr.dev//12'

    Sentry.init({
      dsn: SENTRY_DSN,
      // We recommend adjusting this value in production, or using tracesSampler
      // for finer control
      integrations: [new BrowserTracing()],
      tracesSampleRate: 1,
      release: '4.36.0',
      environment: 'Prepod',
      // debug: false,
      // initialScope: {
      //     user: { id: 42, email: "john.doe@example.com" },
      // },
    })
    $(document).ready(function () {
      var toast = document.querySelector('.redirected-message')
      if (toast) {
        toast.style.display = 'block' // show the toast
        setTimeout(() => {
          toast.style.opacity = '1' // fade in
        }, 100)

        // hide the toast after 5 seconds (5000 milliseconds)
        setTimeout(function () {
          toast.style.opacity = '0' // fade out
          setTimeout(() => {
            toast.style.display = 'none' // hide it after the fade out
          }, 300) // This value should match the CSS transition duration
        }, 5000)
      }
    })
    $('body').removeClass('preload')
    $('.backtotop').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 1000)
    })

    $('.loginButton').click(function () {
      $('html, body').animate(
        {
          scrollTop: $('#logIn').offset().top - 120,
        },
        10
      )
    })
    var section = $('.accordian--holder li')
    var width = $(window).width()
    console.log(width)
    section.removeClass('active')
    $('.accordian--holder li:first-child').addClass('active')
    function toggleAccordion() {
      if (width < 992) {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
        } else {
          section.removeClass('active')
          $(this).addClass('active')
        }
      } else {
        section.removeClass('active')
        $(this).addClass('active')
      }
    }

    section.on('click', toggleAccordion)
  })
}

import(/* webpackChunkName: "Benefits" */ 'dom/benefits').then((Benefits) => Benefits.binds())
import(/* webpackChunkName: "ProductsBanner" */ 'dom/products-banner').then((ProductsBanner) => ProductsBanner.binds())
import(/* webpackChunkName: "Field" */ 'dom/field').then((Field) => Field.binds())
import(/* webpackChunkName: "FieldAddress" */ 'dom/field--address').then((FieldAddress) => FieldAddress.binds())
import(/* webpackChunkName: "Form" */ 'dom/form').then((Form) => Form.binds())
import(/* webpackChunkName: "Googlemap" */ 'dom/googlemap').then((Googlemap) => Googlemap.binds())
import(/* webpackChunkName: "Loading" */ 'dom/loading').then((Loading) => Loading.binds())
import(/* webpackChunkName: "Login" */ 'dom/login').then((Login) => Login.binds())
import(/* webpackChunkName: "Menu" */ 'dom/menu').then((Menu) => Menu.binds())
import(/* webpackChunkName: "Modal" */ 'dom/modal').then((Modal) => Modal.binds())
import(/* webpackChunkName: "ProductsGallery" */ 'dom/products-gallery').then((ProductsGallery) =>
  ProductsGallery.binds()
)
import(/* webpackChunkName: "Products" */ 'dom/products').then((Products) => Products.binds())
import(/* webpackChunkName: "Sections" */ 'dom/sections').then((Sections) => Sections.binds())
import(/* webpackChunkName: "Sidebar" */ 'dom/sidebar').then((Sidebar) => Sidebar.binds())
import(/* webpackChunkName: "Slider" */ 'dom/slider').then((Slider) => Slider.binds())
import(/* webpackChunkName: "Carousel" */ 'dom/carousel').then((Carousel) => Carousel.binds())
import(/* webpackChunkName: "Window" */ 'dom/window').then((Window) => Window.binds())
import(/* webpackChunkName: "JobApply" */ 'dom/job-apply').then((JobApply) => JobApply.binds())

const productsList = document.getElementById('products-list')
const productsFilters = document.getElementById('products-filters')
const productsFiltersTop = document.getElementById('products-filters-top')
const productsFiltersBottom = document.getElementById('products-filters-bottom')
const wholesalerRegistrationForm = document.getElementById('wholesaler-registration-form')
const productCarousels = document.getElementsByClassName('product-carousel')
const eventEnquirySignup = document.getElementById('signup-react')
const jobApplicationForm = document.getElementById('job-application-form')
const dreamJobApplicationForm = document.getElementById('dream-job-application-form')
const supplierRegistrationForm = document.getElementById('supplier-registration-form')

initDOM()
initStore()
